import { X } from 'lucide-react';
import { StatusType } from '../shared/types/inventory';

interface ProductHeaderProps {
  name: string;
  ean: string;
  status: StatusType;
  statusLabel: string;
  onClose: () => void;
}

export const ProductHeader = ({ name, ean, status, statusLabel, onClose }: ProductHeaderProps) => {
  const getStatusColors = () => {
    switch (status) {
      case 'ruptura':
        return 'bg-red-50 text-red-700 border-red-200';
      case 'iminente':
        return 'bg-orange-50 text-orange-700 border-orange-200';
      case 'critica':
        return 'bg-yellow-50 text-yellow-700 border-yellow-200';
      case 'minimo':
        return 'bg-yellow-50 text-yellow-600 border-yellow-200';
      case 'excesso':
        return 'bg-cyan-50 text-cyan-700 border-cyan-200';
      default:
        return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    }
  };

  return (
    <div className="z-10 flex-none border-b border-slate-200 bg-gradient-to-r from-slate-50 to-slate-100 px-4 py-4 sm:px-6 sm:py-5 lg:px-8">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <div className="mb-2 flex flex-wrap items-center gap-2 sm:gap-3">
            <h2 className="break-words text-lg font-semibold tracking-tight text-slate-900 sm:text-xl lg:text-2xl">{name}</h2>
            <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusColors()}`}>
              {statusLabel}
            </span>
          </div>
          <p className="break-all font-mono text-xs text-slate-500 sm:text-sm">EAN: {ean}</p>
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="Fechar detalhes do produto"
          className="group flex-none rounded-lg p-2 transition-all duration-200 hover:bg-slate-200"
        >
          <X className="w-5 h-5 text-slate-400 group-hover:text-slate-600" />
        </button>
      </div>
    </div>
  );
};
